/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/257-frustrated2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M4 10.25v1.5c0 .136.114.25.25.25H6v-2H4.25a.253.253 0 00-.25.25zM7 10h2v2H7v-2zM11.75 10H10v2h1.75c.136 0 .25-.114.25-.25v-1.5a.253.253 0 00-.25-.25z"/><path pid="1" d="M8 0a8 8 0 100 16A8 8 0 008 0zm1.002 5.946c.032-.741.706-1.234 1.275-1.518.543-.271 1.08-.407 1.102-.413a.5.5 0 11.242.97c-.275.07-.602.189-.89.334A.998.998 0 019.999 7a1 1 0 01-1-1l.002-.054zM4.015 4.379a.5.5 0 01.606-.364c.023.006.559.141 1.102.413.568.284 1.243.776 1.275 1.518L7 6a1 1 0 11-1.732-.681 4.638 4.638 0 00-.89-.334.5.5 0 01-.364-.606zM13 11.75c0 .689-.561 1.25-1.25 1.25h-7.5C3.561 13 3 12.439 3 11.75v-1.5C3 9.561 3.561 9 4.25 9h7.5c.689 0 1.25.561 1.25 1.25v1.5z"/>'
  }
})
